import type { FaireProductEntity } from "../../entity_types/product";

export const p_4qyneyxhfg: FaireProductEntity = {
  token: "p_4qyneyxhfg",
  type: "product",
  name: "Cashmere Mix Triangle Scarf",
  brandToken: "b_gzt8ah926u",
  brandName: "Lèmme",
  imageUrl:
    "https://cdn.faire.com/fastly/dbd093b50a0769bc2a6d0849691b3baa034e64b847604c04bdb21ca35e8616c0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a8af5d7f746ee15322d9850a63a3d2f2d8e0a4a7a18c20278c46bf07e32cf3e0.jpeg",
    "https://cdn.faire.com/fastly/c34cb6a1277d868a6459f92ec5454228805c3b8dcf9ea9f4b7186b75de9af1ed.jpeg",
    "https://cdn.faire.com/fastly/c82e47a4b2f0aed2935784486d5d9a4afab156f3563329bf49577c21386f2ea7.jpeg",
    "https://cdn.faire.com/fastly/0c019c094af4ca0cd8507374ad73880ef7d5b88c3abfb4f299b1099128a06f14.jpeg",
    "https://cdn.faire.com/fastly/375770110987eb335c7652de2a421d13406632acb21aae33c26402ad10a60f91.jpeg",
    "https://cdn.faire.com/fastly/7931791a808c3e7bf457ad02c053e7593b7ca34464ba969c3b57030d454a81f3.jpeg",
    "https://cdn.faire.com/fastly/09ea61f9b28e459ab54c3eadb9eb44d7dc95e6203bb141897ebf408f1fe010f2.jpeg",
    "https://cdn.faire.com/fastly/0b09b6b5cf958aebfd9721a26de71e37d860ab7bb332120e16326b3c3bb1a5e3.jpeg",
    "https://cdn.faire.com/fastly/6a1f1b33942ac90d9f0960664651b6b8a9f8dea7d44c53e4ad6cc3f1fe9db0a9.jpeg",
    "https://cdn.faire.com/fastly/7fae5728123f467cde42cd16ee765038dd3cc3403b9a128a4dd607a3dbbda1a7.jpeg",
    "https://cdn.faire.com/fastly/5fcff1e917e8b54dc3733e5989208daa7399c1a2f6bb55d7c8617c4b1ec6aebf.png",
    "https://cdn.faire.com/fastly/3ef708060a315fa6f136b8a8569fc856155f66ccc7d87f751e9983a366564a00.jpeg",
    "https://cdn.faire.com/fastly/0f6d07ae06d8d278c07a8e7d06d6d46d3bca0aec3a6460e17538c960fa749805.png",
    "https://cdn.faire.com/fastly/fddaee565821878619e3c8e365deb349e9b72a74880d7ebf55927d2070c8abc4.jpeg",
    "https://cdn.faire.com/fastly/0f88b65d2c6bdbd6b3c4cdb14ac181cf6ee391d319bc00e44c6258fc25f871df.jpeg",
    "https://cdn.faire.com/fastly/4be024943f3ffa15e09165316b93cff83370781e5c17dbb5bd011037542314b9.jpeg",
    "https://cdn.faire.com/fastly/276169dcd3113624f77de571587e1a6a82f6e8f9e6d795d23512116c84117e06.jpeg",
    "https://cdn.faire.com/fastly/73ee294f376ac7a05ec1a21456655eb9b19dcf8685ff006f60a4552cd3aa38be.jpeg",
    "https://cdn.faire.com/fastly/98626253e47bba8f068294c06eb4ddde5df2a26ba11ab2a63cad7f1545b08eb3.png",
    "https://cdn.faire.com/fastly/5b35680c7800881ce6537160dee8a587faf26d36a429792a58f32f1185b63fd4.png",
    "https://cdn.faire.com/fastly/2a5db3861e1d4fbfbfa1fe8871bf225d9bd264b8edccd289e05024569d3c7d4a.png",
    "https://cdn.faire.com/fastly/8082e2562eff9547850373e23b9605216cd92675ca9e53dd088542ba3d89a61e.jpeg",
  ],
  priceDollars: 26.4,
  description:
    "Soft triangle scarf. Lightweight and versatile, it can be worn over the head, around the neck, or draped on the shoulders. A simple and elegant accessory for every season.\n\nDetails\n\n40% wool, 30% viscose, 20% polyamide, 10% cashmere\n\nGauge 12, 1-ply\n\nEntirely made in Italy\n\nHand wash, visit our guide\n",
  tags: [],
  msrpDollars: 66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:47.279Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
